import { Component, ElementRef, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: 'button.component.html',
  styleUrls: ['button.component.scss']
})
export class ButtonComponent implements OnInit, OnChanges {
  @Input() type: 'submit' | 'button' = 'button';
  @Input() color: 'primary' | 'secondary' | 'success' | 'danger' | 'fb' = 'primary';
  @Input() size: 'xlarge' | 'large' | 'medium' | 'small' | 'full-width' | 'full-format' = 'medium';
  @Input() border: 'dashed';
  @Input() active;
  @Input() disabled;

  rootClass: string;
  classMap: any;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    // Get the component selector ('app-button')
    this.rootClass = this.elementRef.nativeElement.tagName.toLowerCase();
    this.updateClassMap();
  }

  ngOnChanges() {
    this.updateClassMap();
  }

  updateClassMap() {
    this.classMap = {
      [`${this.rootClass}`]: true,
      [`${this.rootClass}--${this.color}`]: Boolean(this.color),
      [`${this.rootClass}--${this.size}`]: Boolean(this.size),
      [`${this.rootClass}--${this.border}`]: Boolean(this.border),
      [`${this.rootClass}--disabled`]: this.disabled,
      [`${this.rootClass}--active`]: this.active
    };
  }
}
